"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Monizze;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Monizze(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#f4921f;}.cls-2{fill:#fff;}.cls-3{fill:#505e5c;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Monizze"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Payment_methods",
    "data-name": "Payment methods"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "monizze"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M9.549,45.106H22.143V57.7H9.549Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M14.549,51.386c0,.65-.143,1.147-.87,1.147-.816,0-.9-.585-.9-1.06V47.751l-1.045.23v3.643a1.78,1.78,0,0,0,1.9,1.915A1.789,1.789,0,0,0,15.6,51.773V47.751l-1.046.23v3.405Zm3.682-2.118a1.961,1.961,0,0,0-1.131.354V49.03l-1.008.244v5.565l1.006-.231V53.184a1.979,1.979,0,0,0,1.133.356,2.138,2.138,0,0,0,0-4.272m-.065,3.353A1.22,1.22,0,1,1,19.33,51.4a1.184,1.184,0,0,1-1.164,1.219"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-3",
    d: "M25.293,57.7l2.349-12.881L31.77,53.26l4.092-8.441L38.3,57.7l-2.385.293-1.009-6.4-3.12,6.4-3.174-6.4-.991,6.4-2.33-.293Zm18.642-9.615a4.959,4.959,0,1,1-5.175,4.954,5.088,5.088,0,0,1,5.175-4.954m0,7.78a2.83,2.83,0,1,0-2.973-2.826,2.919,2.919,0,0,0,2.973,2.826m6.441-7.487,2.2-.22v1.285h.037a3.051,3.051,0,0,1,2.863-1.358,3,3,0,0,1,3.21,3.211v6.4l-2.329.147V51.92c0-.991-.459-1.816-1.5-1.816A2.105,2.105,0,0,0,52.706,52.4v5.3l-2.33.147V48.378Zm12.807-2.495-1.578,1.56-1.579-1.56,1.579-1.559Zm-2.789,2.495,2.33-.22V57.7l-2.33.147V48.379Zm4.275,0h6.752l-4.275,7.3h4.275l-.4,2.018H63.641l4.276-7.3H64.192l.477-2.019Zm8.036,0h6.753l-4.275,7.3h4.275l-.4,2.018H71.678l4.275-7.3H72.229Zm16.313,8.386a6.941,6.941,0,0,1-3.909,1.229,4.959,4.959,0,1,1,0-9.908,4.947,4.947,0,0,1,4.44,2.881l-6.385,3.963a1.862,1.862,0,0,0,1.816.936,5.283,5.283,0,0,0,3.047-1.1Zm-2.4-6.128a2.211,2.211,0,0,0-1.634-.606,2.844,2.844,0,0,0-2.77,2.624,3.636,3.636,0,0,0,.037.624l4.367-2.643Z"
  }))));
}